import styled from 'styled-components'
import { Card } from 'semantic-ui-react'

export const CardShadowMain = styled(Card)`
  -webkit-box-shadow: 0px 0px 30px -20px rgba(0,0,0,0.75) !important;
  -moz-box-shadow: 0px 0px 30px -20px rgba(0,0,0,0.75) !important;
  box-shadow: 0px 0px 30px -20px rgba(0,0,0,0.75) !important;
  border-radius: 10px !important;
`